
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { FileText, Plus } from 'lucide-react';

interface FormulaDetailsProps {
  productId: string;
}

export const FormulaDetails = ({ productId }: FormulaDetailsProps) => {
  // Mock formula data - in a real app, this would come from an API
  const formulas = [
    {
      id: '1',
      name: 'Base Formula v2.1',
      status: 'active',
      componentCount: 8,
      lastUpdated: '2024-01-15'
    }
  ];

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">Related Formulas</CardTitle>
          <Button size="sm" variant="outline">
            <Plus className="h-4 w-4 mr-2" />
            Add Formula
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {formulas.length === 0 ? (
          <div className="text-center py-6 text-muted-foreground">
            <FileText className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm">No formulas associated with this product</p>
          </div>
        ) : (
          <div className="space-y-3">
            {formulas.map((formula) => (
              <div key={formula.id} className="p-3 border rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-medium text-sm">{formula.name}</h3>
                  <Badge variant="outline" className="text-xs">
                    {formula.status}
                  </Badge>
                </div>
                <div className="text-xs text-muted-foreground space-y-1">
                  <p>{formula.componentCount} components</p>
                  <p>Updated {formula.lastUpdated}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
